import { NgModule } from '@angular/core';
import { Lib3Component } from './lib3.component';

@NgModule({
  declarations: [Lib3Component],
  imports: [
  ],
  exports: [Lib3Component]
})
export class Lib3Module { }
